import React, { useEffect, useState } from "react";
import HeaderPrint from "../../../Pdf/PrintHeaderAccount";
import axios from "axios";
import config from "../../../config";
import { calculateColumnTotal } from "../../Shared/Utility";
import pdfStyles from "../../../Pdf/pdfStyles";
import PrintFooter from "../../../Pdf/PrintFooter";
import { PrintFormateNumber } from "../../../Pdf/PrintFormateNumber";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
} from "@react-pdf/renderer";
import { locale } from "dayjs";
import { Spin } from "antd";

const PrintCashReceivable = () => {
  const UserID = localStorage.getItem("ID");
  const AccessKey = localStorage.getItem("AccessKey");
  const urlParams = new URLSearchParams(window.location.search);

  const PageNo = urlParams.get("currentPage");
  const EndDate = urlParams.get("EndDate");
  const OrderBy =
    urlParams.get("OrderBy") || urlParams.get("orderby") || "1";
  const includeEmployee = urlParams.get("includeEmployee") === "1";
  const showOnlyEmployee = urlParams.get("showOnlyEmployee") === "1";

  const [CashReceiveableList, setCashReceiveableList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Print Cash Receivable";
    setLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      PageNo: 1,
      PageSize: 10000,
      EndDate: EndDate,
      OrderBy: OrderBy,
      IncludeEmployee: includeEmployee && !showOnlyEmployee,
      ShowOnlyEmployee: showOnlyEmployee,
    };
  
    var api_config = {
      method: "post",
      url: config.base_url + "Report/GetReceiveableReport",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
 
        if (response.data.status_code == 1) {
          setCashReceiveableList(response.data.listofLedger);

          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  
  const generateData = () => {
    if (CashReceiveableList.length > 0) {
      return CashReceiveableList.map((item, index) => {
        return (
          <View key={index} style={pdfStyles.row}>
            <View style={[pdfStyles.td, { width: 50 }]}>
              <Text style={pdfStyles.tdValue}>{index + 1}</Text>
            </View>
            
            <View style={[pdfStyles.td, { width: 150 }]}>
              <Text style={pdfStyles.tdValue}>{item.Name}</Text>
            </View>

            <View style={[pdfStyles.td, { width: 100 }]}>
              <Text style={pdfStyles.tdValue}>{item.Mobile_No}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 120 }]}>
              <Text style={pdfStyles.tdValue}>{item.Account_Type_BE?.Name}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 150 }]}>
              <Text style={[pdfStyles.tdValue, { textAlign: "right" }]}>
                {PrintFormateNumber(item.Balance)}
              </Text>
            </View>
            
          </View>
        );
      });
    }
  };

  const MyDocument = () => (
    <Document>
      <Page size="A4" style={pdfStyles.page}>
        <HeaderPrint  />

        <View style={pdfStyles.section}>
          <View style={pdfStyles.title}>
            <Text style={pdfStyles.pagetitle}>Cash Receivable</Text>
          </View>
          <View style={pdfStyles.table}>
            <View style={pdfStyles.tableHead}>
              <View style={[pdfStyles.th, { width: 50 }]}>
                <Text style={pdfStyles.thValue}>SR.</Text>
              </View>
             
              <View style={[pdfStyles.th, { width: 150 }]}>
                <Text style={pdfStyles.thValue}>Name</Text>
              </View>

              <View style={[pdfStyles.th, { width: 100 }]}>
                <Text style={pdfStyles.thValue}>Mobile No</Text>
              </View>
              <View style={[pdfStyles.th, { width: 120 }]}>
                <Text style={pdfStyles.thValue}>Account Type</Text>
              </View>
              <View style={[pdfStyles.th, { width: 150 }]}>
                <Text style={[pdfStyles.thValue, { textAlign: "right" }]}>
                  Amount
                </Text>
              </View>
             
            </View>

            {generateData()}

            <View style={pdfStyles.tableHead}>
             
              <View style={[pdfStyles.th, { width: 420 }]}>
                <Text
                  style={[
                    pdfStyles.thValue,
                    { textAlign: "right", fontWeight: "bold" },
                  ]}
                >
                  Total
                </Text>
              </View>
              <View style={[pdfStyles.th, { width: 150 }]}>
                <Text
                  style={[
                    pdfStyles.thValue,
                    { textAlign: "right", fontWeight: "bold" },
                  ]}
                >
                  {PrintFormateNumber(Math.round(
                    calculateColumnTotal(CashReceiveableList, "Balance")
                  ))}
                </Text>
              </View>
            </View>
          </View>
          <View
            style={{ marginBottom: 60, marginTop: 0, top: 10, bottom: 10 }}
            fixed
          >
            <Text
              style={{ fontSize: "8pt" }}
              render={({ pageNumber, totalPages }) =>
                `Page ${pageNumber} / ${totalPages}`
              }
            />
          </View>
        </View>
        <PrintFooter fixed/>
      </Page>
    </Document>
  );

  return (
    <>
      <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
        {loading ? (
          <div
            style={{
              height: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spin />
          </div>
        ) : (
          <PDFViewer width="100%" height="100%" fileName="CashReceivable.pdf">
            <MyDocument />
          </PDFViewer>
        )}
      </div>
    </>
  );
};

export default PrintCashReceivable;
